import { PNG } from "pngjs";
import { decode } from "blurhash";

/**
 * Converts a BlurHash string into a base64 data URL.
 *
 * @param hash - BlurHash value to decode.
 * @param width - Output image width.
 * @param height - Output image height.
 * @returns Encoded PNG data URL.
 */
export function blurhashToDataURL(hash: string, width = 32, height = 32): string {
	const pixels = decode(hash, width, height);
	const png = new PNG({ width, height });

	for (let i = 0; i < pixels.length; i++) {
		png.data[i] = pixels[i];
	}

	const buffer = PNG.sync.write(png);
	const base64 = buffer.toString("base64");

	return `data:image/png;base64,${base64}`;
}
